(() => {
  const reduce = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fmt = (d) => d.toLocaleDateString('tr-TR', { day: 'numeric', month: 'long' });
  const addBiz = (n) => { const d = new Date(); let k = 0; while (k < n) { d.setDate(d.getDate() + 1); const w = d.getDay(); if (w !== 0 && w !== 6) k++; } return d; };

  const initGallery = (root) => {
    const stage = root.querySelector('[data-sv-stage]');
    if (!stage || stage.dataset.ready) return;
    stage.dataset.ready = '1';
    const thumbs = [...root.querySelectorAll('[data-sv-thumb]')];
    const count = root.querySelector('[data-sv-count]');
    const total = stage.children.length;
    const mark = (i) => {
      thumbs.forEach((t, j) => t.setAttribute('aria-current', String(i === j)));
      if (count) count.textContent = `${i + 1} / ${total}`;
    };
    thumbs.forEach((t, i) => t.addEventListener('click', () => {
      stage.scrollTo({ left: stage.clientWidth * i, behavior: reduce() ? 'auto' : 'smooth' });
      mark(i);
    }));
    let tm;
    stage.addEventListener('scroll', () => { clearTimeout(tm); tm = setTimeout(() => mark(Math.round(stage.scrollLeft / Math.max(stage.clientWidth, 1))), 60); }, { passive: true });
  };

  const initBuy = (root) => {
    const form = root.querySelector('[data-sv-form]');
    if (!form || form.dataset.ready) return;
    form.dataset.ready = '1';
    const input = form.querySelector('input[name="quantity"]');
    form.querySelectorAll('[data-sv-qty]').forEach((b) => b.addEventListener('click', () => {
      const v = Math.max(1, Math.min(99, (parseInt(input.value, 10) || 1) + Number(b.dataset.svQty)));
      input.value = v;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }));
    const select = form.querySelector('select[name="id"]');
    const priceEl = root.querySelector('[data-sv-price]');
    const oldEl = root.querySelector('[data-sv-old]');
    const badge = root.querySelector('[data-sv-badge]');
    const submit = form.querySelector('[type="submit"]');
    const money = (c) => new Intl.NumberFormat('tr-TR', { style: 'currency', currency: root.dataset.currency || 'TRY' }).format(c / 100);
    if (select) select.addEventListener('change', () => {
      const o = select.selectedOptions[0];
      const p = Number(o.dataset.price), c = Number(o.dataset.compare);
      if (priceEl) priceEl.textContent = money(p);
      if (oldEl) { oldEl.hidden = !(c > p); oldEl.textContent = money(c); }
      if (badge) { badge.hidden = !(c > p); badge.textContent = `%${Math.round((1 - p / c) * 100)} İNDİRİM`; }
      if (submit) { submit.disabled = o.dataset.available !== 'true'; }
      const url = new URL(location.href); url.searchParams.set('variant', o.value); history.replaceState(null, '', url);
    });
    const sticky = root.querySelector('[data-sv-sticky]');
    if (sticky && submit && 'IntersectionObserver' in window) {
      new IntersectionObserver(([e]) => sticky.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0)).observe(submit);
    }
  };

  const initShip = (root) => {
    root.querySelectorAll('[data-sv-ship]').forEach((el) => {
      const [a, b] = el.dataset.svShip.split('-').map(Number);
      if (a > 0 && b >= a) el.textContent = a === b ? fmt(addBiz(a)) : `${fmt(addBiz(a))} – ${fmt(addBiz(b))}`;
    });
  };

  const initRail = (root) => {
    const rail = root.querySelector('[data-sv-rail]');
    if (!rail || rail.dataset.ready) return;
    rail.dataset.ready = '1';
    const arrows = [...root.querySelectorAll('[data-sv-dir]')];
    const update = () => arrows.forEach((b) => {
      b.disabled = Number(b.dataset.svDir) < 0 ? rail.scrollLeft <= 2 : rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
    });
    const step = () => { const c = rail.firstElementChild; return c ? c.getBoundingClientRect().width + 18 : 260; };
    arrows.forEach((b) => b.addEventListener('click', () => rail.scrollBy({ left: step() * Number(b.dataset.svDir), behavior: reduce() ? 'auto' : 'smooth' })));
    rail.addEventListener('keydown', (e) => {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      e.preventDefault();
      rail.scrollBy({ left: (e.key === 'ArrowRight' ? 1 : -1) * step(), behavior: reduce() ? 'auto' : 'smooth' });
    });
    rail.addEventListener('scroll', update, { passive: true });
    addEventListener('resize', update);
    update();
  };

  const icons = {
    muted: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 9h4l5-4v14l-5-4H4z"/><path d="m17 9 4 6M21 9l-4 6"/></svg>',
    sound: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 9h4l5-4v14l-5-4H4z"/><path d="M17 8a5 5 0 0 1 0 8M19.5 5.5a8.5 8.5 0 0 1 0 13"/></svg>',
    play: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5v14l11-7z"/></svg>',
    pause: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 5h4v14H7zM13 5h4v14h-4z"/></svg>'
  };
  const initVideos = (root) => {
    root.querySelectorAll('.sv-vid').forEach((card) => {
      if (card.dataset.ready) return;
      card.dataset.ready = '1';
      const v = card.querySelector('video');
      const play = card.querySelector('.sv-vid__play');
      const mute = card.querySelector('.sv-vid__mute');
      if (!v) return;
      v.muted = true; v.playsInline = true; v.loop = true; v.removeAttribute('controls');
      const sync = () => {
        const on = !v.paused;
        card.classList.toggle('is-playing', on);
        if (play) { play.innerHTML = on ? icons.pause : icons.play; play.setAttribute('aria-label', on ? 'Videoyu durdur' : 'Videoyu oynat'); }
      };
      v.addEventListener('play', sync); v.addEventListener('pause', sync);
      if (play) play.addEventListener('click', () => { v.paused ? v.play().catch(() => {}) : v.pause(); });
      if (mute) mute.addEventListener('click', () => {
        v.muted = !v.muted;
        if (!v.muted && v.paused) v.play().catch(() => {});
        mute.innerHTML = v.muted ? icons.muted : icons.sound;
        mute.setAttribute('aria-pressed', String(!v.muted));
        mute.setAttribute('aria-label', v.muted ? 'Sesi aç' : 'Sesi kapat');
      });
      if (card.closest('[data-sv-autoplay="true"]') && !reduce() && 'IntersectionObserver' in window) {
        new IntersectionObserver(([e]) => { if (e.isIntersecting) { if (v.muted) v.play().catch(() => {}); } else v.pause(); }, { threshold: .6 }).observe(card);
      }
      sync();
    });
  };

  const init = (scope) => {
    scope.querySelectorAll('[data-sv-product]').forEach((r) => { initGallery(r); initBuy(r); initShip(r); });
    scope.querySelectorAll('[data-sv-carousel]').forEach((r) => { initRail(r); initVideos(r); });
  };
  const boot = () => init(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true }); else boot();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
